import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box,
  Typography,
} from "@material-ui/core";
import WarningIcon from "@material-ui/icons/Warning";

/**
 * Reusable confirmation dialog (replaces window.confirm).
 *
 * Props:
 * - open, title, message, confirmLabel, cancelLabel
 * - confirmColor: "primary" | "secondary" | "danger"
 * - loading: disables buttons while action runs
 * - onConfirm, onCancel
 */
const ConfirmDialog = ({
  open,
  title = "Confirm",
  message = "Are you sure you want to continue?",
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  confirmColor = "danger",
  loading = false,
  onConfirm,
  onCancel,
}) => {
  const confirmButtonStyle =
    confirmColor === "danger"
      ? { backgroundColor: "#d32f2f", color: "#fff" }
      : confirmColor === "secondary"
      ? { backgroundColor: "#f57c00", color: "#fff" }
      : { backgroundColor: "#009E60", color: "#fff" };

  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onCancel}
      maxWidth="xs"
      fullWidth
      disableBackdropClick={loading}
      disableEscapeKeyDown={loading}
    >
      <DialogTitle disableTypography>
        <Box display="flex" alignItems="center" style={{ gap: 8 }}>
          <WarningIcon style={{ color: "#f57c00" }} />
          <Typography variant="h6" component="span">
            {title}
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <DialogContentText style={{ color: "rgba(0,0,0,0.75)", marginBottom: 0 }}>
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions style={{ padding: "8px 16px 16px" }}>
        <Button onClick={onCancel} disabled={loading} variant="outlined">
          {cancelLabel}
        </Button>
        <Button
          onClick={onConfirm}
          disabled={loading}
          variant="contained"
          style={confirmButtonStyle}
        >
          {loading ? "Please wait..." : confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
